<template lang="pug">
div(v-html="title").page-title
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 2.6em;
  font-weight: bolder;
  text-align: center;
  margin: 0.5em;
  border-bottom: solid 0.1em #6d1419;
  white-space: pre-line;
  line-height: 1.6;
  letter-spacing: 0.05em;
  ::v-deep small {
    font-size: 1em;
    font-weight: normal;
  }
  & + & {
    margin-top: 0;
  }
}
</style>
